import React from 'react'
//import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PersonalData from './PersonalData/PersonalData';
import PreferenceData from './PreferenceData/PreferenceData';
import HeaderRegistro from './HeaderRegistro';

const DataClient = () => {
  return (
    <div className='pt-3 pb-5 bg-white w-100'>
      <Container fluid>
        <Container fluid className='w-100'>
        <HeaderRegistro/>
        </Container>
        <Row>
          <Col xs={12} md={6}><PersonalData/></Col>
          <Col xs={12} md={6}><PreferenceData/></Col>
        </Row>
      </Container>
    </div>
  )
}

export default DataClient